import { render } from "./edgesCards.vue?vue&type=template&id=2c884c12&scoped=true"
import script from "./edgesCards.vue?vue&type=script&lang=js"
export * from "./edgesCards.vue?vue&type=script&lang=js"

import "./edgesCards.vue?vue&type=style&index=0&id=2c884c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c884c12"]])

export default __exports__